import React, { useState } from "react";
import { Route, Redirect } from "react-router-dom";
import auth from "../auth/auth";
import NavbarHeader from "../components/NavBar/navbarHeader"
import { USER } from "../constants/constant";


export const ProtectedRoute = ({
  component: Component, 
  ...rest
}) => {
 
  return (

    <div className="main-body">
      <div>
        <NavbarHeader></NavbarHeader>
      </div>
      <div className="container-fluid">
      <Route
            {...rest}
            render={props => {
              if (auth.isAuthenticated()) {
                if(props.match.path == '/orders/:orderStatus?') {
                  let featureConfig = USER.user.featureConfig ? JSON.parse(USER.user.featureConfig) : null;
                  if(featureConfig?.isNewUpsellFlowLive){
                    return (
                      <Redirect
                        to={{
                          pathname: "/dependantOrders",
                          state: {
                            from: props.location
                          }
                        }}
                      />
                    );
                  }
                }
                else if(props.match.path == '/dependantOrders/:orderStatus?') {
                  let featureConfig = USER.user.featureConfig ? JSON.parse(USER.user.featureConfig) : null;
                  if(!featureConfig?.isNewUpsellFlowLive){
                    return (
                      <Redirect
                        to={{
                          pathname: "/orders",
                          state: {
                            from: props.location
                          }
                        }}
                      />
                    );
                  }
                }

                return <Component {...props} />;
              } else {
                return (
                  <Redirect
                    to={{
                      pathname: "/login",
                      state: {
                        from: props.location
                      }
                    }}
                  />
                );
              }
            }}
          />
      </div>
    </div>




  );
};